import formModel from 'models/form-model';

const SidebarToggle = {
    view: ({attrs: {onclick}}) => 
        <div class={`icon-down sidebar-toggle ${ formModel.editingFeatureId ? ' is-editing' : ''}`} onclick={() => onclick()} />
};

export default SidebarToggle;
